module.exports = __webpack_public_path__ + "static/img/空间or美陈-橱窗设计.b659fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/空间or美陈-橱窗设计.png
// module id = THw4
// module chunks = 1